<template>
    <div class="container-fluid dashboard-2">
        <div class="row">
            <ChatWindow />
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
const ChatWindow = defineAsyncComponent(() => import("@/components/theme/supports/ChatWindow.vue"))
</script>
